import { initializeApp } from 'firebase/app';
import { getFirestore, doc, getDoc, setDoc, updateDoc, increment, collection, addDoc, query, where, orderBy, limit, getDocs } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyD4uxKeV4QsHgtoSXIh8HyfOvcf9Dnx33Y',
  authDomain: 'aivantage-6c972.firebaseapp.com',
  projectId: 'aivantage-6c972',
  storageBucket: 'aivantage-6c972.firebasestorage.app',
  messagingSenderId: '621924482382',
  appId: '1:621924482382:web:777403a2935f7975c8721f',
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app, 'aivantage');

const SITE = 'downloadmediahub';
const MIN_SHOW_COUNT = 25;
const MIN_SHOW_RATINGS = 10;

export async function incrementDownloadCount() {
  const ref = doc(db, 'stats', SITE);
  try {
    const snap = await getDoc(ref);
    if (snap.exists()) {
      await updateDoc(ref, { count: increment(1) });
    } else {
      await setDoc(ref, { count: 1 });
    }
  } catch (_) {}
}

export async function getDownloadCount() {
  try {
    const snap = await getDoc(doc(db, 'stats', SITE));
    const count = snap.exists() ? snap.data().count : 0;
    return count >= MIN_SHOW_COUNT ? count : null;
  } catch (_) { return null; }
}

export async function submitRating({ stars, comment }) {
  try {
    await addDoc(collection(db, 'ratings', SITE, 'entries'), {
      stars,
      comment: comment.slice(0, 150),
      site: SITE,
      createdAt: new Date(),
    });
  } catch (_) {}
}

export async function getRatingSummary() {
  try {
    const snap = await getDocs(collection(db, 'ratings', SITE, 'entries'));
    if (snap.size < MIN_SHOW_RATINGS) return null;
    let total = 0;
    snap.forEach(d => { total += d.data().stars; });
    return { avg: (total / snap.size).toFixed(1), count: snap.size };
  } catch (_) { return null; }
}

export async function getTopComments() {
  try {
    const q = query(
      collection(db, 'ratings', SITE, 'entries'),
      where('stars', '>=', 4),
      where('comment', '!=', ''),
      orderBy('comment'),
      orderBy('createdAt', 'desc'),
      limit(5)
    );
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ stars: d.data().stars, comment: d.data().comment }));
  } catch (_) { return []; }
}
